import React, { useState } from "react";
import ProgressBar from "../Common/ProgressBar";
import RadioButton from "../../../UI/RadioButton";
const BankStatement = ({
  className,
  slideChange,
  textHeadingLine1,
  textHeadingLine2,
  validation,
  backClick,
}) => {
  const [checkedQuestionOne, setCheckedQuestionOne] = useState("unchecked");
  const [checkedQuestionTwo, setCheckedQuestionTwo] = useState("unchecked");
  const [checkedQuestionThree, setCheckedQuestionThree] = useState("unchecked");

  const nextSlide = async (e) => {
    if (e.target.value === "210") {
      setCheckedQuestionOne("checked");
      setCheckedQuestionTwo("unchecked");
      setCheckedQuestionThree("unchecked")
      slideChange(e);
    }
    if (e.target.value === "211") {
      setCheckedQuestionOne("unchecked");
      setCheckedQuestionTwo("checked");
      setCheckedQuestionThree("unchecked")
      slideChange(e);
    }
    if (e.target.value === "212") {
        setCheckedQuestionOne("unchecked");
        setCheckedQuestionTwo("unchecked");
        setCheckedQuestionThree("checked")
        slideChange(e);
    }
  };
  return (
    <>
      <div id="slide-bankstmt" className={`${className}`}>
        <ProgressBar value="12" />

        <h3> {textHeadingLine1} </h3>
        <div className="btn-comm">
          <RadioButton
            value="210"
            name="bankStatement"
            className="radio-button"
            labelName="Payslips"
            labelClassName={`option_but next9 ${checkedQuestionOne}`}
            onClick={nextSlide}
            validation={validation()}
          />
          <RadioButton
            value="211"
            name="bankStatement"
            className="radio-button"
            labelName="Bank Statements"
            labelClassName={`option_but next9 ${checkedQuestionTwo}`}
            onClick={nextSlide}
            validation={validation()}
          />
          <RadioButton
            value="212"
            name="bankStatement"
            className="radio-button"
            labelName="Can't remember"
            labelClassName={`option_but next9 ${checkedQuestionThree}`}
            onClick={nextSlide}
            validation={validation()}
          />
        </div>
        <p className="text-center">
          <a
            className="back1 back-btn btn-link"
            name="backToReg"
            children="<< Previous"
            onClick={backClick}
          ></a>
        </p>
      </div>
    </>
  );
};
export default BankStatement;